var LG_YKR_H_209E = {
  name: "LG YKR-H/209E",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [211,0,4,127,2,178,1,137,35,36,17,139,2,49,6,132,2,0,0,73,242,73,60,254,73,255,249,159,255,159,255,255,255,252,207,201,38,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,172,1,145,35,40,17,135,2,61,6,138,2,0,0,73,242,73,60,254,73,255,249,63,255,159,255,255,231,255,51,242,73,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [211,0,4,128,2,174,1,140,35,38,17,137,2,65,6,128,2,0,0,73,242,73,39,63,146,127,254,79,255,231,255,255,249,255,204,252,147,57,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [211,0,4,138,2,172,1,166,35,49,17,136,2,48,6,149,2,0,0,73,242,73,51,63,146,127,254,79,255,231,255,255,249,255,204,252,146,78,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [211,0,4,136,2,163,1,140,35,45,17,135,2,52,6,145,2,0,0,73,242,73,36,207,228,159,255,147,255,249,255,255,254,127,243,63,36,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [211,0,4,136,2,172,1,134,2,54,6,137,35,49,17,149,2,0,0,43,234,174,191,171,255,245,255,253,255,255,254,255,237,250,173,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [211,0,4,136,2,172,1,143,35,47,17,137,2,47,6,125,2,0,0,73,242,73,38,79,228,159,255,147,255,249,255,255,254,127,243,63,36,201,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [211,0,4,136,2,162,1,137,35,45,17,138,2,50,6,143,2,0,0,73,242,73,50,79,228,159,255,147,255,249,255,255,254,127,243,63,36,146,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [211,0,4,125,2,174,1,143,35,46,17,129,2,51,6,136,2,0,0,73,242,73,36,147,249,39,255,228,255,254,127,255,255,159,252,207,201,60,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [211,0,4,126,2,162,1,138,2,57,6,147,35,39,17,140,2,0,0,43,234,175,191,87,255,235,255,251,255,255,253,255,219,245,93,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [211,0,4,128,2,170,1,135,2,52,6,143,35,44,17,142,2,0,0,43,234,171,223,171,255,245,255,253,255,255,254,255,237,250,182,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [211,0,4,135,2,168,1,137,2,45,6,149,35,44,17,138,2,0,0,43,234,173,223,171,255,245,255,253,255,255,254,255,237,250,171,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,172,1,135,2,63,6,146,35,36,17,132,2,0,0,43,234,170,239,213,255,250,255,254,255,255,255,127,246,253,93,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,155,1,136,2,63,6,143,35,35,17,132,2,0,0,43,234,174,223,171,255,245,255,253,255,255,254,255,237,250,173,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [211,0,4,128,2,174,1,145,35,42,17,131,2,61,6,128,2,0,0,73,242,73,38,103,228,159,255,147,255,249,255,255,254,127,243,63,36,201,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,173,1,163,35,36,17,131,2,63,6,132,2,0,0,73,242,73,50,103,228,159,255,147,255,249,255,255,254,127,243,63,36,146,73,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,175,1,131,2,62,6,149,35,46,17,143,2,0,0,43,234,170,183,234,255,253,127,255,127,255,255,191,251,126,175,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,175,1,175,35,44,17,131,2,57,6,152,2,0,0,73,242,73,60,159,146,127,254,79,255,231,255,255,249,255,204,252,146,124,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,157,1,148,35,2,17,161,2,62,6,150,2,0,0,73,242,73,60,254,73,255,252,255,254,127,255,255,159,252,207,201,38,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,150,1,132,2,59,6,147,35,44,17,144,2,0,0,43,234,171,191,171,255,251,255,251,255,255,253,255,219,245,106,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,177,1,145,2,62,6,145,35,22,17,147,2,0,0,43,234,173,191,171,255,251,255,251,255,255,253,255,219,245,85,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [211,0,4,128,2,152,1,132,2,61,6,142,35,44,17,129,2,0,0,43,234,170,223,213,255,253,255,253,255,255,254,255,237,250,190,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,155,1,138,2,61,6,144,35,35,17,136,2,0,0,43,234,174,191,171,255,251,255,251,255,255,253,255,219,245,94,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,176,1,134,2,57,6,177,35,42,17,123,2,0,0,43,234,171,95,213,255,253,255,253,255,255,254,255,237,250,183,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [211,0,4,131,2,167,1,137,2,49,6,156,35,29,17,127,2,0,0,43,234,173,95,213,255,253,255,253,255,255,254,255,237,250,171,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [211,0,4,128,2,172,1,136,2,59,6,143,35,34,17,135,2,0,0,43,234,170,175,234,255,254,255,254,255,255,255,127,246,253,93,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,171,1,134,2,56,6,170,35,41,17,128,2,0,0,43,234,175,191,87,255,247,255,247,255,255,251,255,183,234,182,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [211,0,4,131,2,167,1,145,2,43,6,163,35,22,17,127,2,0,0,43,234,171,223,171,255,251,255,251,255,255,253,255,219,245,107,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [211,0,4,139,2,167,1,146,2,48,6,166,35,26,17,139,2,0,0,43,234,173,223,171,255,251,255,251,255,255,253,255,219,245,85,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [211,0,4,131,2,172,1,167,2,53,6,181,35,7,17,128,2,0,0,43,234,170,239,213,255,253,255,253,255,255,254,255,237,250,189,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [211,0,4,132,2,170,1,149,2,49,6,161,35,21,17,128,2,0,0,43,234,174,223,171,255,251,255,251,255,255,253,255,219,245,93,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,171,1,144,2,50,6,161,35,26,17,127,2,0,0,43,234,171,111,213,255,253,255,253,255,255,254,255,237,250,182,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [211,0,4,125,2,173,1,128,2,58,6,143,35,49,17,124,2,0,0,43,234,173,111,213,255,253,255,253,255,255,254,255,237,250,171,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,171,1,134,2,56,6,152,35,38,17,128,2,0,0,43,234,170,183,234,255,254,255,254,255,255,255,127,246,253,93,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_MID",
      command: [211,0,4,133,2,167,1,147,2,50,6,163,35,18,17,129,2,0,0,43,234,175,95,171,255,251,255,251,255,255,253,255,219,245,90,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,171,35,40,17,130,2,153,1,135,2,63,6,172,2,0,0,146,170,73,37,82,170,164,149,85,85,84,170,170,170,170,85,85,85,85,85,85,42,170,170,82,170,146,74,148,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,128,2,173,1,137,2,51,6,158,35,41,17,141,2,0,0,43,234,171,191,171,255,247,255,251,255,255,253,255,219,245,109,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,169,1,166,35,22,17,148,2,43,6,148,2,0,0,73,242,73,51,63,146,127,254,127,255,159,255,255,231,255,51,242,73,51,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,133,2,173,1,153,35,30,17,142,2,55,6,144,2,0,0,73,242,73,36,207,228,159,255,159,255,231,255,255,249,255,204,252,147,147,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,131,2,170,1,144,2,52,6,182,35,23,17,138,2,0,0,43,234,174,191,171,255,247,255,251,255,255,253,255,219,245,90,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,174,1,139,2,56,6,158,35,37,17,140,2,0,0,43,234,171,95,213,255,251,255,253,255,255,254,255,237,250,181,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,133,2,167,1,202,35,19,17,145,2,42,6,143,2,0,0,73,242,73,50,79,228,159,255,159,255,231,255,255,249,255,204,252,146,73,49,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,152,1,149,35,50,17,131,2,59,6,131,2,0,0,73,242,73,36,147,249,39,255,231,255,249,255,255,254,127,243,63,36,249,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,174,1,153,35,45,17,132,2,63,6,122,2,0,0,73,242,73,62,126,73,255,249,255,254,127,255,255,159,252,207,201,39,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,169,1,178,35,49,17,132,2,62,6,132,2,0,0,73,242,73,39,159,146,127,254,127,255,159,255,255,231,255,51,242,76,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,153,1,147,35,42,17,135,2,56,6,133,2,0,0,73,242,73,51,159,146,127,254,127,255,159,255,255,231,255,51,242,73,57,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,172,1,138,2,59,6,155,35,38,17,135,2,0,0,43,234,170,239,213,255,251,255,253,255,255,254,255,237,250,187,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,154,1,160,2,63,6,147,35,10,17,132,2,0,0,43,234,174,223,171,255,247,255,251,255,255,253,255,219,245,91,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,171,1,161,2,62,6,168,35,4,17,122,2,0,0,43,234,171,111,213,255,251,255,253,255,255,254,255,237,250,181,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,177,1,134,2,60,6,152,35,40,17,124,2,0,0,43,234,173,111,213,255,251,255,253,255,255,254,255,237,250,170,209,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,172,1,131,2,63,6,148,35,48,17,131,2,0,0,43,234,170,183,234,255,253,255,254,255,255,255,127,246,253,94,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,172,1,135,2,52,6,144,35,42,17,131,2,0,0,43,234,175,95,171,255,247,255,251,255,255,253,255,219,245,93,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,126,2,168,1,145,35,23,17,147,2,59,6,132,2,0,0,73,242,73,60,254,73,255,249,159,255,159,255,255,231,255,51,242,73,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,179,1,134,2,58,6,143,35,42,17,129,2,0,0,43,234,171,191,171,255,246,255,253,255,255,254,255,237,250,182,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,126,2,173,1,135,2,60,6,148,35,42,17,143,2,0,0,43,234,173,191,171,255,246,255,253,255,255,254,255,237,250,171,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,129,2,173,1,135,2,65,6,145,35,35,17,136,2,0,0,43,234,170,223,213,255,251,127,254,255,255,255,127,246,253,93,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,131,2,172,1,136,2,64,6,142,35,36,17,130,2,0,0,43,234,174,191,171,255,246,255,253,255,255,254,255,237,250,173,81,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,173,1,132,2,49,6,176,35,41,17,131,2,0,0,43,234,171,95,213,255,251,127,254,255,255,255,127,246,253,90,168,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,177,1,131,2,61,6,148,35,42,17,132,2,0,0,43,234,173,95,213,255,251,127,254,255,255,255,127,246,253,85,84,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,176,1,152,2,56,6,146,35,20,17,137,2,0,0,43,234,170,175,234,255,253,191,255,127,255,255,191,251,126,175,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,157,1,137,2,62,6,171,35,39,17,135,2,0,0,43,234,175,191,87,255,237,255,251,255,255,253,255,219,245,95,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,168,1,131,2,58,6,146,35,44,17,139,2,0,0,43,234,171,223,171,255,246,255,253,255,255,254,255,237,250,183,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,129,2,171,1,135,2,63,6,141,35,37,17,144,2,0,0,43,234,173,223,171,255,246,255,253,255,255,254,255,237,250,171,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,173,1,146,2,61,6,147,35,17,17,149,2,0,0,43,234,170,239,213,255,251,127,254,255,255,255,127,246,253,93,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,131,2,172,1,137,2,59,6,144,35,38,17,162,2,0,0,43,234,174,223,171,255,246,255,253,255,255,254,255,237,250,173,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,176,1,138,2,63,6,144,35,42,17,144,2,0,0,43,234,171,111,213,255,251,127,254,255,255,255,127,246,253,90,226],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,170,1,149,2,63,6,150,35,12,17,144,2,0,0,43,234,173,111,213,255,251,127,254,255,255,255,127,246,253,85,113,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,129,2,176,1,132,2,61,6,145,35,48,17,143,2,0,0,43,234,170,183,234,255,253,191,255,127,255,255,191,251,126,175,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,175,1,129,2,64,6,144,35,50,17,173,2,0,0,43,234,175,95,171,255,246,255,253,255,255,254,255,237,250,174,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [211,0,4,145,35,46,17,137,2,50,6,139,2,158,1,140,2,0,0,169,36,170,164,148,146,73,84,146,73,36,146,74,146,73,36,146,73,36,164,146,73,36,146,73,36,146,164,146,73,36,165,36,146,170,170,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [211,0,4,126,2,171,1,141,35,44,17,136,2,57,6,149,2,0,0,73,242,73,39,63,146,127,254,79,255,249,255,255,242,127,243,63,36,252,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,168,1,136,2,56,6,150,35,46,17,147,2,0,0,43,234,173,191,171,255,245,255,255,127,255,253,127,246,253,87,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [211,0,4,128,2,177,1,129,2,61,6,150,35,48,17,145,2,0,0,43,234,170,223,213,255,250,255,255,191,255,254,191,251,126,173,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,172,1,128,2,60,6,143,35,50,17,150,2,0,0,43,234,174,191,171,255,245,255,255,127,255,253,127,246,253,85,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [211,0,4,130,2,176,1,136,2,63,6,138,35,35,17,141,2,0,0,43,234,171,95,213,255,250,255,255,191,255,254,191,251,126,174,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,163,1,135,2,63,6,153,35,35,17,147,2,0,0,43,234,173,95,213,255,250,255,255,191,255,254,191,251,126,171,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,166,1,143,35,37,17,135,2,62,6,170,2,0,0,73,242,73,36,147,249,39,255,228,255,255,159,255,255,39,255,51,242,76,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [211,0,4,132,2,173,1,135,2,60,6,145,35,37,17,142,2,0,0,43,234,175,191,87,255,235,255,254,255,255,250,255,237,250,170,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [211,0,4,142,35,37,17,137,2,59,6,129,2,162,1,170,2,0,0,169,36,170,169,37,36,146,169,36,146,73,36,149,36,146,73,36,146,73,73,36,146,73,36,146,73,37,73,36,146,73,74,73,37,82,74,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,172,1,141,35,44,17,132,2,63,6,148,2,0,0,73,242,73,51,159,146,127,254,79,255,249,255,255,242,127,243,63,36,156,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [211,0,4,131,2,62,6,143,35,46,17,130,2,173,1,144,2,0,0,114,73,254,76,146,79,36,146,73,36,147,146,73,36,146,73,36,201,36,146,73,36,146,73,39,36,146,73,38,100,146,121,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [211,0,4,135,2,63,6,174,35,36,17,128,2,172,1,153,2,0,0,114,73,249,51,36,147,201,36,146,73,36,228,146,73,36,146,73,50,73,36,146,73,36,146,73,201,36,146,73,153,36,159,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [211,0,4,130,2,174,1,134,2,54,6,154,35,39,17,141,2,0,0,43,234,171,111,213,255,250,255,255,191,255,254,191,251,126,174,177,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [211,0,4,134,2,62,6,140,35,39,17,128,2,160,1,141,2,0,0,114,73,249,204,146,79,36,146,73,36,147,146,73,36,146,73,36,201,36,146,73,36,146,73,39,36,146,73,38,100,146,124,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [211,0,4,128,2,173,1,131,2,52,6,150,35,46,17,148,2,0,0,43,234,170,183,234,255,253,127,255,223,255,255,95,253,191,86,172,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_LOW",
      command: [211,0,4,133,2,167,1,132,2,61,6,145,35,37,17,141,2,0,0,43,234,175,95,171,255,245,255,255,127,255,253,127,246,253,85,88,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [211,0,4,146,35,41,17,135,2,59,6,127,2,178,1,129,2,0,0,169,36,170,164,148,146,73,84,146,73,36,146,73,73,36,146,73,36,146,82,73,36,146,73,36,146,73,82,73,36,146,82,146,73,85,74,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [211,0,4,148,35,44,17,132,2,61,6,129,2,173,1,131,2,0,0,169,36,170,169,41,36,146,169,36,146,73,36,146,146,73,36,146,73,36,164,146,73,36,146,73,36,146,164,146,73,36,165,36,146,169,42,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,174,1,138,35,37,17,136,2,61,6,129,2,0,0,73,242,73,51,63,146,127,255,63,255,231,255,255,201,255,204,252,146,100,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,165,1,152,35,35,17,134,2,61,6,135,2,0,0,73,242,73,36,207,228,159,255,207,255,249,255,255,242,127,243,63,36,201,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,175,1,132,2,59,6,150,35,44,17,125,2,0,0,43,234,174,191,171,255,251,255,254,255,255,250,255,237,250,170,168,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [211,0,4,132,2,169,1,133,2,62,6,139,35,45,17,143,2,0,0,43,234,171,95,213,255,253,255,255,127,255,253,127,246,253,95,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,157,1,134,2,62,6,142,35,41,17,141,2,0,0,43,234,173,95,213,255,253,255,255,127,255,253,127,246,253,87,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,174,1,134,2,61,6,148,35,40,17,138,2,0,0,43,234,170,175,234,255,254,255,255,191,255,254,191,251,126,173,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,163,1,132,2,57,6,155,35,45,17,142,2,0,0,43,234,175,191,87,255,247,255,253,255,255,245,255,219,245,87,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,174,1,158,2,61,6,144,35,9,17,138,2,0,0,43,234,171,223,171,255,251,255,254,255,255,250,255,237,250,187,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,173,1,131,2,64,6,146,35,49,17,139,2,0,0,43,234,173,223,171,255,251,255,254,255,255,250,255,237,250,173,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,178,1,135,2,63,6,148,35,39,17,146,2,0,0,43,234,170,239,213,255,253,255,255,127,255,253,127,246,253,90,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,170,1,151,2,66,6,168,35,13,17,149,2,0,0,43,234,174,223,171,255,251,255,254,255,255,250,255,237,250,170,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [211,0,4,128,2,171,1,137,2,58,6,149,35,38,17,147,2,0,0,43,234,171,111,213,255,253,255,255,127,255,253,127,246,253,94,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,176,1,135,2,58,6,171,35,45,17,140,2,0,0,43,234,173,111,213,255,253,255,255,127,255,253,127,246,253,87,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [211,0,4,128,2,177,1,144,2,65,6,146,35,23,17,141,2,0,0,43,234,170,183,234,255,254,255,255,191,255,254,191,251,126,173,177,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,158,1,136,2,62,6,143,35,37,17,135,2,0,0,43,234,175,95,171,255,251,255,254,255,255,250,255,237,250,171,98],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,149,35,45,17,132,2,62,6,130,2,152,1,135,2,0,0,169,36,170,164,148,146,73,84,146,73,36,146,74,73,36,146,73,36,146,82,73,36,146,73,36,146,73,82,73,36,146,82,146,73,85,82,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,141,35,38,17,134,2,177,1,136,2,53,6,129,2,0,0,146,170,73,36,169,85,82,74,170,170,170,85,85,85,85,82,170,170,170,170,170,74,170,170,148,170,164,149,73,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,143,35,46,17,128,2,173,1,134,2,56,6,141,2,0,0,146,170,73,37,41,85,82,74,170,170,170,85,85,85,85,82,170,170,170,170,170,74,170,170,148,170,164,146,164,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,174,1,146,35,38,17,138,2,57,6,133,2,0,0,73,242,73,36,207,228,159,255,159,255,249,255,255,242,127,243,63,36,204,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,136,2,175,1,136,2,48,6,143,35,45,17,176,2,0,0,43,234,174,191,171,255,247,255,254,255,255,250,255,237,250,171,81,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,128,2,180,1,133,2,57,6,139,35,43,17,141,2,0,0,43,234,171,95,213,255,251,255,255,127,255,253,127,246,253,93,81,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,159,1,131,2,47,6,144,35,48,17,125,2,0,0,43,234,173,95,213,255,251,255,255,127,255,253,127,246,253,86,168,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,136,2,175,1,136,2,53,6,141,35,37,17,141,2,0,0,43,234,170,175,234,255,253,255,255,191,255,254,191,251,126,173,84,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,174,1,137,2,45,6,142,35,39,17,153,2,0,0,43,234,175,191,87,255,239,255,253,255,255,245,255,219,245,85,81,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,136,2,176,1,137,2,51,6,135,35,45,17,141,2,0,0,43,234,171,223,171,255,247,255,254,255,255,250,255,237,250,191,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,175,1,139,2,50,6,147,35,36,17,144,2,0,0,43,234,173,223,171,255,247,255,254,255,255,250,255,237,250,175,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,157,1,138,2,56,6,135,35,35,17,150,2,0,0,43,234,170,239,213,255,251,255,255,127,255,253,127,246,253,91,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,173,1,140,2,53,6,139,35,33,17,147,2,0,0,43,234,174,223,171,255,247,255,254,255,255,250,255,237,250,171,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,136,2,155,1,138,2,47,6,170,35,43,17,149,2,0,0,43,234,171,111,213,255,251,255,255,127,255,253,127,246,253,93,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,133,2,151,1,147,35,52,17,129,2,59,6,143,2,0,0,73,242,73,50,103,228,159,255,159,255,249,255,255,242,127,243,63,36,153,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,124,2,161,1,132,2,53,6,140,35,49,17,164,2,0,0,43,234,170,183,234,255,253,255,255,191,255,254,191,251,126,173,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,138,2,174,1,138,2,49,6,166,35,45,17,139,2,0,0,43,234,175,95,171,255,247,255,254,255,255,250,255,237,250,170,226],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,163,35,40,17,129,2,174,1,133,2,64,6,147,2,0,0,146,170,73,37,82,170,164,149,85,85,84,165,85,85,85,82,170,170,170,170,170,74,170,170,148,170,164,146,74,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,143,35,35,17,138,2,61,6,128,2,169,1,141,2,0,0,169,36,170,169,41,36,146,169,36,146,73,36,148,164,146,73,36,146,73,73,36,146,73,36,146,73,37,73,36,146,73,74,73,37,82,74,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,141,35,37,17,130,2,170,1,138,2,59,6,145,2,0,0,146,170,73,37,41,85,82,74,170,170,170,82,170,170,170,169,85,85,85,85,85,37,85,85,74,85,82,73,82,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,132,2,180,1,148,35,48,17,130,2,56,6,144,2,0,0,73,242,73,36,207,228,159,255,153,255,254,127,255,252,159,252,207,201,51,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,126,2,172,1,143,35,43,17,132,2,60,6,170,2,0,0,73,242,73,57,63,146,127,254,103,255,249,255,255,242,127,243,63,36,147,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,176,1,142,35,43,17,131,2,66,6,143,2,0,0,73,242,73,38,79,228,159,255,153,255,254,127,255,252,159,252,207,201,57,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,171,1,150,35,48,17,130,2,59,6,142,2,0,0,73,242,73,50,79,228,159,255,153,255,254,127,255,252,159,252,207,201,38,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,168,1,142,35,44,17,130,2,58,6,141,2,0,0,73,242,73,36,147,249,39,255,230,127,255,159,255,255,39,255,51,242,76,147,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,154,1,134,2,57,6,144,35,37,17,135,2,0,0,43,234,175,191,87,255,237,255,254,255,255,250,255,237,250,170,177,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,161,1,134,2,59,6,137,35,45,17,127,2,0,0,43,234,171,223,171,255,246,255,255,127,255,253,127,246,253,95,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,131,2,171,1,139,2,57,6,143,35,39,17,126,2,0,0,43,234,173,223,171,255,246,255,255,127,255,253,127,246,253,87,162],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,169,1,132,2,57,6,152,35,45,17,130,2,0,0,43,234,170,239,213,255,251,127,255,191,255,254,191,251,126,173,209,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,131,2,177,1,135,2,58,6,147,35,36,17,133,2,0,0,43,234,174,223,171,255,246,255,255,127,255,253,127,246,253,85,209,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,163,1,135,2,45,6,141,35,43,17,139,2,0,0,43,234,171,111,213,255,251,127,255,191,255,254,191,251,126,174,209,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,126,2,163,1,135,2,53,6,147,35,41,17,128,2,0,0,43,234,173,111,213,255,251,127,255,191,255,254,191,251,126,171,104,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,154,1,131,2,65,6,143,35,43,17,127,2,0,0,43,234,170,183,234,255,253,191,255,223,255,255,95,253,191,86,180,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,129,2,170,1,131,2,58,6,142,35,46,17,138,2,0,0,43,234,175,95,171,255,246,255,255,127,255,253,127,246,253,85,104,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [211,0,4,131,2,175,1,141,35,44,17,134,2,56,6,132,2,0,0,73,242,73,60,254,73,255,249,63,255,207,255,255,231,255,51,242,73,153,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [211,0,4,142,35,47,17,130,2,175,1,131,2,56,6,136,2,0,0,146,170,73,36,169,85,82,74,170,170,170,74,170,170,170,165,85,85,85,85,85,74,170,170,148,170,164,148,148,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [211,0,4,136,2,44,6,137,35,44,17,137,2,165,1,140,2,0,0,114,73,249,153,36,147,201,36,146,73,36,228,146,73,36,146,73,146,73,36,146,73,36,146,73,50,73,36,146,102,73,39,243,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,173,1,147,35,41,17,134,2,46,6,122,2,0,0,73,242,73,36,207,228,159,255,147,255,252,255,255,254,127,243,63,36,242,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [211,0,4,125,2,182,1,139,35,37,17,135,2,53,6,139,2,0,0,73,242,73,57,63,146,127,254,79,255,243,255,255,249,255,204,252,146,114,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [211,0,4,129,2,157,1,136,2,60,6,139,35,41,17,147,2,0,0,43,234,171,95,213,255,250,255,255,127,255,255,127,246,253,91,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [211,0,4,135,2,184,1,131,2,51,6,140,35,52,17,140,2,0,0,43,234,173,95,213,255,250,255,255,127,255,255,127,246,253,85,168,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [211,0,4,134,2,171,1,137,2,55,6,144,35,37,17,139,2,0,0,43,234,170,175,234,255,253,127,255,191,255,255,191,251,126,174,168,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [211,0,4,133,2,176,1,137,2,53,6,146,35,37,17,148,2,0,0,43,234,175,191,87,255,235,255,253,255,255,253,255,219,245,90,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [211,0,4,131,2,176,1,144,2,52,6,137,35,22,17,150,2,0,0,43,234,171,223,171,255,245,255,254,255,255,254,255,237,250,181,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [211,0,4,137,2,173,1,137,2,54,6,149,35,36,17,137,2,0,0,43,234,173,223,171,255,245,255,254,255,255,254,255,237,250,170,168,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [211,0,4,130,2,171,1,135,2,54,6,142,35,39,17,139,2,0,0,43,234,170,239,213,255,250,255,255,127,255,255,127,246,253,95,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [211,0,4,134,2,176,1,150,2,55,6,142,35,16,17,143,2,0,0,43,234,174,223,171,255,245,255,254,255,255,254,255,237,250,175,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [211,0,4,135,2,151,1,136,2,52,6,159,35,45,17,147,2,0,0,43,234,171,111,213,255,250,255,255,127,255,255,127,246,253,91,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [211,0,4,131,2,54,6,142,35,45,17,134,2,172,1,148,2,0,0,114,73,249,204,146,79,36,146,73,36,147,146,73,36,146,73,38,73,36,146,73,36,146,73,36,201,36,146,73,153,36,159,146,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,165,1,142,35,51,17,130,2,52,6,148,2,0,0,73,242,73,36,153,249,39,255,228,255,255,63,255,255,159,252,207,201,57,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_LOW",
      command: [211,0,4,127,2,154,1,137,2,57,6,145,35,36,17,142,2,0,0,43,234,175,95,171,255,245,255,254,255,255,254,255,237,250,173,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [211,0,4,136,2,180,1,141,35,41,17,138,2,52,6,150,2,0,0,73,242,73,60,254,73,255,252,255,255,63,255,255,159,252,207,201,39,145,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [211,0,4,137,2,182,1,140,2,48,6,142,35,44,17,143,2,0,0,43,234,171,191,171,255,251,255,253,255,255,253,255,219,245,110,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [211,0,4,137,2,173,1,138,2,52,6,138,35,38,17,138,2,0,0,43,234,173,191,171,255,251,255,253,255,255,253,255,219,245,87,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [211,0,4,137,2,177,1,146,35,33,17,140,2,43,6,126,2,0,0,73,242,73,36,207,228,159,255,207,255,243,255,255,249,255,204,252,147,153,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [211,0,4,136,2,53,6,139,35,36,17,133,2,179,1,129,2,0,0,114,73,249,57,36,147,201,36,146,73,36,153,36,146,73,36,146,100,146,73,36,146,73,36,146,76,146,73,36,153,146,73,243,49,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,172,1,147,35,44,17,134,2,55,6,132,2,0,0,73,242,73,38,79,228,159,255,207,255,243,255,255,249,255,204,252,147,38,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,155,1,151,2,54,6,149,35,13,17,125,2,0,0,43,234,173,95,213,255,253,255,254,255,255,254,255,237,250,170,209,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [211,0,4,125,2,179,1,146,2,62,6,143,35,17,17,131,2,0,0,43,234,170,175,234,255,254,255,255,127,255,255,127,246,253,94,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,174,1,149,35,37,17,137,2,63,6,136,2,0,0,73,242,73,62,126,73,255,252,255,255,63,255,255,159,252,207,201,39,36,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [211,0,4,126,2,174,1,140,35,48,17,130,2,61,6,130,2,0,0,73,242,73,39,159,146,127,255,63,255,207,255,255,231,255,51,242,76,201,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [211,0,4,130,2,181,1,143,35,46,17,134,2,58,6,142,2,0,0,73,242,73,51,159,146,127,255,63,255,207,255,255,231,255,51,242,73,50,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [211,0,4,135,2,177,1,143,35,39,17,133,2,54,6,127,2,0,0,73,242,73,36,231,228,159,255,207,255,243,255,255,249,255,204,252,147,146,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [211,0,4,126,2,160,1,140,35,19,17,148,2,64,6,132,2,0,0,73,242,73,57,159,146,127,255,63,255,207,255,255,231,255,51,242,73,146,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [211,0,4,124,2,174,1,140,35,7,17,157,2,50,6,129,2,0,0,73,242,73,38,103,228,159,255,207,255,243,255,255,249,255,204,252,147,36,145,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [211,0,4,127,2,171,1,135,2,55,6,148,35,38,17,142,2,0,0,43,234,173,111,213,255,253,255,254,255,255,254,255,237,250,170,168,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [211,0,4,134,2,149,1,145,2,54,6,149,35,23,17,143,2,0,0,43,234,170,183,234,255,254,255,255,127,255,255,127,246,253,95,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_MID",
      command: [211,0,4,129,2,164,1,133,2,52,6,140,35,48,17,141,2,0,0,43,234,175,95,171,255,251,255,253,255,255,253,255,219,245,95,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,168,1,152,35,37,17,139,2,56,6,135,2,0,0,73,242,73,60,254,73,255,249,255,255,63,255,255,159,252,207,201,38,76,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,128,2,173,1,141,35,36,17,137,2,57,6,146,2,0,0,73,242,73,39,63,146,127,254,127,255,207,255,255,231,255,51,242,76,147,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,130,2,170,1,135,2,47,6,137,35,43,17,145,2,0,0,43,234,173,191,171,255,247,255,253,255,255,253,255,219,245,85,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,133,2,179,1,137,2,54,6,162,35,38,17,130,2,0,0,43,234,170,223,213,255,251,255,254,255,255,254,255,237,250,190,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,133,2,171,1,139,2,53,6,142,35,37,17,140,2,0,0,43,234,174,191,171,255,247,255,253,255,255,253,255,219,245,94,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,182,1,133,2,55,6,145,35,49,17,125,2,0,0,43,234,171,95,213,255,251,255,254,255,255,254,255,237,250,183,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,177,1,139,2,56,6,151,35,37,17,127,2,0,0,43,234,173,95,213,255,251,255,254,255,255,254,255,237,250,171,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,128,2,175,1,156,2,56,6,144,35,6,17,145,2,0,0,43,234,170,175,234,255,253,255,255,127,255,255,127,246,253,93,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,126,2,174,1,139,2,58,6,165,35,35,17,138,2,0,0,43,234,175,191,87,255,239,255,251,255,255,251,255,183,234,182,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,136,2,170,1,139,2,46,6,144,35,38,17,147,2,0,0,43,234,171,223,171,255,247,255,253,255,255,253,255,219,245,107,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,178,1,144,2,45,6,149,35,20,17,128,2,0,0,43,234,173,223,171,255,247,255,253,255,255,253,255,219,245,85,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,182,1,138,2,53,6,143,35,42,17,139,2,0,0,43,234,170,239,213,255,251,255,254,255,255,254,255,237,250,189,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,132,2,177,1,138,2,63,6,141,35,37,17,135,2,0,0,43,234,174,223,171,255,247,255,253,255,255,253,255,219,245,93,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,174,1,137,2,57,6,141,35,38,17,140,2,0,0,43,234,171,111,213,255,251,255,254,255,255,254,255,237,250,182,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,128,2,171,1,139,2,51,6,149,35,38,17,146,2,0,0,43,234,173,111,213,255,251,255,254,255,255,254,255,237,250,171,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,129,2,158,1,138,2,50,6,143,35,38,17,143,2,0,0,43,234,170,183,234,255,253,255,255,127,255,255,127,246,253,93,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,134,2,177,1,137,2,53,6,150,35,37,17,129,2,0,0,43,234,175,95,171,255,247,255,253,255,255,253,255,219,245,90,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,136,2,181,1,157,35,48,17,134,2,50,6,153,2,0,0,73,242,73,60,254,73,255,249,159,255,207,255,255,231,255,51,242,73,146,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,137,2,177,1,138,2,46,6,142,35,43,17,148,2,0,0,43,234,171,191,171,255,246,255,254,255,255,254,255,237,250,181,81,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,135,2,175,1,139,2,50,6,142,35,37,17,141,2,0,0,43,234,173,191,171,255,246,255,254,255,255,254,255,237,250,170,168,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,138,2,158,1,152,2,48,6,142,35,14,17,141,2,0,0,43,234,170,223,213,255,251,127,255,127,255,255,127,246,253,95,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,178,1,131,2,59,6,142,35,50,17,141,2,0,0,43,234,174,191,171,255,246,255,254,255,255,254,255,237,250,175,136],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,135,2,177,1,138,2,49,6,142,35,35,17,141,2,0,0,43,234,171,95,213,255,251,127,255,127,255,255,127,246,253,91,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,157,1,136,2,56,6,146,35,40,17,144,2,0,0,43,234,173,95,213,255,251,127,255,127,255,255,127,246,253,85,226],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,134,2,160,1,136,2,51,6,149,35,44,17,145,2,0,0,43,234,170,175,234,255,253,191,255,191,255,255,191,251,126,174,226],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,162,35,36,17,127,2,172,1,136,2,63,6,142,2,0,0,146,170,73,37,84,170,164,149,85,85,84,165,85,85,85,74,170,170,170,170,170,149,85,85,41,85,73,37,42,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,146,35,47,17,129,2,170,1,131,2,59,6,134,2,0,0,146,170,73,36,170,85,82,74,170,170,170,82,170,170,170,165,85,85,85,85,85,74,170,170,148,170,164,148,149,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,130,2,161,1,146,35,35,17,139,2,52,6,150,2,0,0,73,242,73,51,159,146,127,254,103,255,243,255,255,249,255,204,252,146,73,196],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,126,2,176,1,144,35,43,17,132,2,65,6,147,2,0,0,73,242,73,36,231,228,159,255,153,255,252,255,255,254,127,243,63,36,243,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,151,1,150,35,16,17,151,2,63,6,140,2,0,0,73,242,73,57,159,146,127,254,103,255,243,255,255,249,255,204,252,146,115,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,175,1,132,2,55,6,143,35,47,17,165,2,0,0,43,234,171,111,213,255,251,127,255,127,255,255,127,246,253,91,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,172,1,132,2,57,6,145,35,44,17,140,2,0,0,43,234,173,111,213,255,251,127,255,127,255,255,127,246,253,85,177,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,169,1,137,2,57,6,148,35,38,17,139,2,0,0,43,234,170,183,234,255,253,191,255,191,255,255,191,251,126,174,177,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,127,2,179,1,135,2,48,6,143,35,38,17,178,2,0,0,43,234,175,95,171,255,246,255,254,255,255,254,255,237,250,173,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,128,2,172,1,143,35,39,17,134,2,61,6,148,2,0,0,73,242,73,63,249,39,255,230,127,255,255,255,254,127,243,63,36,153,49,0],
    }
    ]
};

export default LG_YKR_H_209E